import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-release-view-config-modal',
  templateUrl: './release-view-config-modal.component.html',
  styleUrls: ['./release-view-config-modal.component.scss']
})
export class ReleaseViewConfigModalComponent implements OnInit {

  headerText: string;
  bodyText: string;
  buttonText: string;

  constructor(
    private activeModal: NgbActiveModal,
  ) {}

  async ngOnInit() {
  }

  close() {
    this.activeModal.close(false);
  }
}
